module.exports = __webpack_public_path__ + "img/1562445005.b5d44d80.jpg";